import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Registered from './Registered/'
import Browse from './Browse/'
import Checkout from './Checkout/'
import PermissionSplash from 'components/PermissionSplash'

export default class FieldPrograms extends React.Component {
	render() {
		let routeProps = this.props
		const read =
			this.props.userRole !== undefined
				? this.props.userRole.some((role) => {
						return (
							role.section === 'Field' && role.access_read === '1'
						)
				  })
				: false
		if (
			(this.props.variant === 'admin' && read === true) ||
			this.props.variant !== 'admin'
		) {
			return (
				<Switch>
					<Route
						path='/portal/field/Registered'
						render={() => <Registered {...routeProps} />}
					/>
					<Route
						path='/portal/field/Browse All'
						render={() => <Browse {...routeProps} />}
					/>
					<Route
						path='/portal/field/Checkout'
						render={() => <Checkout {...routeProps} />}
					/>
					<Route
						path='*'
						render={() => (
							<Redirect to='/portal/field/Registered' />
						)}
					/>
				</Switch>
			)
		} else {
			return <PermissionSplash />
		}
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/index.jsx